import { setLocale } from '@/config/locale'
import { Vue, Component, Prop, Ref } from 'vue-property-decorator'

@Component({
    name: 'LanguageSwitch'
})
export class LanguageSwitchImpl extends Vue {
    onLanguageChange(value) {
        this.$i18n.locale = value
        setLocale(value)
    }
}
